import axios from "../../../axios";

export const instances = async () => {
    try {        
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/dashboard/instances`);               
        return data;
    } catch (e) {
        console.log("errors", e)
    }
}
